import React from 'react';
import { PropTypes } from 'prop-types';
import GalleryThumb from './GalleryThumb';

const GallerySection = (props) => {
    return (
        <section id={props.id} className="container">
            <h2>{props.name}</h2>
            {props.body && props.body.length > 0 && <p>{props.body}</p>}
            <div className="row">
                {props.artworks.map((artwork, i) => {
                    return (
                        <GalleryThumb key={i} name={artwork.name}
                            imageUrl={artwork.imageThumbnailUrl}
                            availableAsOriginal={artwork.availableAsOriginal}
                            availableAsPrint={artwork.availableAsPrint}
                            availableAsCard={artwork.availableAsCard} />
                    );
                })}
            </div>
        </section>
    );
};

GallerySection.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    body: PropTypes.string,
    artworks: PropTypes.array.isRequired
};

export default GallerySection;



// WEBPACK FOOTER //
// ./src/components/gallery/GallerySection.js